import { Grid,makeStyles}              from '@material-ui/core';
import React                           from 'react';

const useStyles =  makeStyles (theme =>({
    ContenedorLectura:{
        width:'502px',
                  [theme.breakpoints.down(502)]:{
            width:'350px',
            padding: '60px 0 0 0',
        },
        [theme.breakpoints.down(350)]:{
            width:'300px',
            padding: '30px 0 0 0',
        },
    },
    ContainerTitulo:{
        margin:'0 0 34px 0',
        '& .Titulo':{
            letterSpacing: '0px',
            color: '#0C88D6',
            margin:'0',
            textAlign:'center',
            font:'43px fredoka one',
            lineHeight:'52px',
            [theme.breakpoints.down(502)]:{
                font:'30px fredoka one',
                lineHeight:'32px',
            },
            [theme.breakpoints.down(350)]:{
                font:'28px fredoka one',
                lineHeight:'32px',
            },
        },
    },
    Parrafo1:{
        margin:' 0 0 36px 0',
        '& .Lectura':{
            margin:'0 0 36px 0',
            color:'#000',
            font:'18px lato',
            lineHeight :'28px',
            letterSpacing: '0.17px',
            [theme.breakpoints.down(502)]:{
                font:'16px lato',
                lineHeight :'21px',
                letterSpacing: '0.09px',
            },
            [theme.breakpoints.down(350)]:{
                font:'12px lato',
                lineHeight :'17px',
                letterSpacing: '0.09px',
            },
        },
    
        '& .Imagen':{
             width:'100%',
        }, 

    }
}));

const Ciudadanía_para_la_niñez = () => {
const classes = useStyles ()
    return (  
        <Grid container item justifyContent="center" xs={12} className={classes.Contenedor}>
            <Grid container item className={classes.ContenedorLectura} justifyContent="center">
                <Grid container item sm={12} className={classes.ContainerTitulo} justifyContent="center">
                    <h2 className="Titulo" >
                        Distanciamiento social<br/> y acercamiento virtual                   
                    </h2>
                </Grid>
                <Grid container item sm={12} className={classes.Parrafo1} justifyContent="center">
                    <Grid container sm={12}>
                      <p className="Lectura">
                        La pandemia de Covid-19 cambió la forma en que nos comunicamos. Limitó el 
                        contacto humano y las interacciones sociales en general, lo cual ha hecho que los
                         aparatos electrónicos y las computadoras sean las herramientas principales de 
                         comunicación a distancia. Ahora las personas son capaces de compartir información 
                         en documentos digitales y de entablar conversaciones a través de videollamadas. 
                         Éste era un método que existía desde tiempo atrás, pero la emergencia sanitaria hizo 
                         que se volviera más famoso y, en muchas ocasiones, el único.
                      </p>
                    </Grid>
                    <Grid container justifyContent="center" sm={12}>
                        <img className="Imagen" src="https://img-lecturas-cdl.s3.us-west-1.amazonaws.com/Imagenes+Lecturas/Img3ro/Sesion53/1.png" alt="Tarjeta" />
                    </Grid>
                </Grid>
                <Grid container item sm={12} className={classes.Parrafo1} justifyContent="center">
                    <Grid container sm={12}>
                        <p className="Lectura">
                            También hubo modificaciones en las actividades cotidianas. Por ejemplo, ahora se 
                            confirman citas a través de redes sociales y puedes revisar las condiciones 
                            meteorológicas antes de salir de casa para decidir si llevas una sombrilla o un abrigo. 
                            Muchos eventos que antes requerían la presencia de la gente encontraron la forma 
                            de llevarse a cabo con poca asistencia e incluso se filman para transmitirse en 
                            plataformas electrónicas. De esta manera pueden verlos más personas en el 
                            momento que deseen.<br/><br/> 
                            
                            Actualmente ya no es necesario salir para tener comida, existen aplicaciones para 
                            ordenarla a domicilio y algunos negocios reúnen la despensa para toda una familia y 
                            la llevan a las puertas de su hogar. Incluso en el supermercado se escanean los 
                            productos para pagarlos sin necesidad de un intermediario que cobre uno por uno. El 
                            uso del dinero electrónico se multiplicó y cada vez hay más establecimientos que 
                            aceptan este método de pago, lo cual también es una transformación en la manera de 
                            adquirir productos y servicios. <br/><br/>
                            
                            Las personas ocupan con mayor frecuencia la tecnología a causa de esta situación y
                            de muchas otras. Es verdad que facilita la vida y hace más ágiles diversos 
                            procedimientos que antes eran tardados o complicados. Pero su uso inadecuado o 
                            excesivo puede generar diversos tipos de afecciones físicas y psicológicas. De hecho, 
                            es algo que ya está ocurriendo, paulatinamente se modifican nuestras interacciones 
                            y nos acostumbramos cada vez más a esta situación. <br/><br/>
                            
                            Las consecuencias son múltiples y afectan a toda la población de forma distinta.
                            Perder el interés por otras actividades, aislarse de los demás y no hacer ejercicio son 
                            algunos de los efectos más comunes. Todo esto reduce las habilidades sociales y la 
                            falta de ellas termina dañando nuestra capacidad de entender el mundo y a la gente.
                        </p>
                    </Grid>
                    <Grid container justifyContent="center" sm={12}>
                        <img className="Imagen" src="https://img-lecturas-cdl.s3.us-west-1.amazonaws.com/Imagenes+Lecturas/Img3ro/Sesion53/2.png" alt="Tarjeta" />
                    </Grid>
                </Grid>
                <Grid container item sm={12} className={classes.Parrafo1} justifyContent="center">
                    <Grid container sm={12}>
                        <p className="Lectura">
                            Es importante desarrollar prácticas que promuevan un uso apropiado y responsable
                            de la tecnología, así como reflexionar sobre sus efectos para buscar maneras de 
                            reducirlos. ¿Y tú? ¿Utilizas con responsabilidad la tecnología que tienes a tu alcance?
                        </p>
                    </Grid>
                </Grid>
        </Grid>
    </Grid>
    );
}
 
export default Ciudadanía_para_la_niñez ;
